import React from 'react';

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.2222 3H3.77778C2.79111 3 2 3.8 2 4.77778V15.4444C2 16.4222 2.79111 17.2222 3.77778 17.2222H7.33333V15.4444H3.77778V6.55556H16.2222V15.4444H12.6667V17.2222H16.2222C17.2 17.2222 18 16.4222 18 15.4444V4.77778C18 3.8 17.2089 3 16.2222 3ZM10 8.33333L6.44444 11.8889H9.11111V17.2222H10.8889V11.8889H13.5556L10 8.33333Z" fill="currentColor" />
  </svg>
);
